import { useState } from 'react';
import SiteFooter from '../components/layout/SiteFooter';
import ServiceCard from '../components/services/ServiceCard';
import ServiceModal from '../components/services/ServiceModal';
import { servicesList, servicesPageIntro } from '../data/servicesPageData';

function ServicesPage() {
  const [activeService, setActiveService] = useState(null);

  return (
    <div className="bg-brand-bg">
      <main className="mx-auto max-w-7xl px-6 pb-16 pt-10 sm:px-8 sm:pb-24 sm:pt-14">
        <section className="rounded-3xl border border-brand-petal/80 bg-gradient-to-r from-brand-mist/90 via-brand-bg to-brand-sage/70 px-7 py-10 shadow-sm sm:px-10">
          <h1 className="text-5xl text-brand-text sm:text-6xl">{servicesPageIntro.title}</h1>
          <p className="mt-4 max-w-3xl text-base leading-8 text-brand-text/80 sm:text-lg">
            {servicesPageIntro.subtitle}
          </p>
        </section>

        <section className="mt-10 grid gap-5 md:grid-cols-2">
          {servicesList.map((service) => (
            <ServiceCard key={service.id} service={service} onLearnMore={setActiveService} />
          ))}
        </section>
      </main>

      <SiteFooter />

      <ServiceModal service={activeService} onClose={() => setActiveService(null)} />
    </div>
  );
}

export default ServicesPage;